import { BodyText } from "@/components/ui";
import type * as fhirTypes from "fhir/r4";
import { ClipboardPlus, PenTool } from "lucide-react";
import { useSignatures } from "./useSignatures";

interface SignaturesProps {
  encounter: fhirTypes.Encounter;
}

export const Signatures = ({ encounter }: SignaturesProps) => {
  const { admittingSignature, primarySignature, secondariesSignature } =
    useSignatures(encounter);

  return (
    <div className="mt-2 flex flex-col gap-2">
      {admittingSignature && (
        <div
          className="flex items-center gap-1"
          data-testid="admitting-signature"
        >
          <ClipboardPlus size={12} />
          <BodyText tag="p" size="xs" textColor="secondary">
            {admittingSignature}
          </BodyText>
        </div>
      )}
      {secondariesSignature && (
        <div
          className="flex items-center gap-1"
          data-testid="secondaries-signature"
        >
          <PenTool size={12} />
          <BodyText tag="p" size="xs" textColor="secondary">
            {secondariesSignature}
          </BodyText>
        </div>
      )}
      {primarySignature && (
        <div
          className="flex items-center gap-1"
          data-testid="primary-signature"
        >
          <PenTool size={12} />
          <BodyText tag="p" size="xs" textColor="secondary">
            {primarySignature}
          </BodyText>
        </div>
      )}
    </div>
  );
};
